if (!window.Eurus.loadedScript.has('cart-term.js')) {
  window.Eurus.loadedScript.add('cart-term.js');

  // Utility: get checkout button safely
  function getCheckoutButton() {
    return document.querySelector('#checkout-submit');
  }

  // Apply enable / disable logic
  function syncCheckoutState() {
    const btn = getCheckoutButton();
    const agreed = localStorage.cart_term_checked === 'agreed';

    if (btn) {
      btn.disabled = !agreed;
    }
  }

  // Watch for DOM changes (Eurus replaces cart HTML)
  const observer = new MutationObserver(() => {
    syncCheckoutState();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {

      Alpine.data('xCartTerm', (message) => ({
        message: message,
        checked: false,
        t: null,

        init() {
          // Restore state
          this.checked = localStorage.cart_term_checked === 'agreed';

          // Initial sync
          syncCheckoutState();

          // Watch checkbox change
          this.$watch('checked', (value) => {
            this.save();
            localStorage.cart_term_checked = value ? 'agreed' : 'not agreed';
            syncCheckoutState();
          });

          // Eurus validation hook
          document.addEventListener('eurus:cart:validate', () => {
            this.checked = localStorage.cart_term_checked === 'agreed';

            if (!this.checked) {
              Alpine.store('xCartHelper').validated = false;
              syncCheckoutState();
              alert('אנא אשר את תנאי השימוש לפני המעבר לתשלום');
            }
          });
        },

        save() {
          clearTimeout(this.t);
          this.t = setTimeout(() => {
            Alpine.store('xCartHelper').updateCart({
              attributes: {
                'Terms and conditions': this.checked ? 'agreed' : 'not agreed'
              }
            });
          }, 200);
        }
      }));
    });
  });

  // Absolute last line of defense (click interception)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('#checkout-submit');
    if (!btn) return;

    if (localStorage.cart_term_checked !== 'agreed') {
      e.preventDefault();
      e.stopImmediatePropagation();
      alert('יש לאשר את תנאי השימוש לפני המעבר לתשלום');
    }
  });
}